import React, { Component } from "react";
import { listaVistaPreviaAyuda } from "./ayudaInformePlan";

class AyudaInformePlanModal extends Component {
  render() {
    const {
      abierto,
      cargando,
      error,
      sugerencia,
      aviso,
      meta,
      formato,
      onCerrar,
      onAplicar,
      onRegenerar,
    } = this.props;
    if (!abierto) return null;

    const escolar = formato === "ESCOLAR";
    const items = listaVistaPreviaAyuda(sugerencia, escolar);

    return (
      <div
        className="ic-modalOverlay"
        onClick={cargando ? undefined : onCerrar}
      >
        <div
          className="ic-modalCard ic-modalCard-ayuda"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="ic-modalHeader">
            <h4>Ayuda Informe — borrador con IA</h4>
            <button type="button" className="boton" onClick={onCerrar}>
              Cerrar
            </button>
          </div>

          {cargando && (
            <div className="ic-ayuda-loading" role="status" aria-live="polite" aria-busy="true">
              <div className="ic-ayuda-spinner" aria-hidden="true" />
              <p className="ic-ayuda-loading-texto">
                Generando borrador con inteligencia artificial a partir de los reportes
                diarios…
              </p>
              <p className="ic-ayuda-loading-hint">Esto puede tardar unos segundos.</p>
            </div>
          )}

          {!cargando && error && <div className="ic-msg ic-msg-error-top">{error}</div>}

          {!cargando && !error && sugerencia && (
            <>
              {aviso && <p className="ic-hint ic-ayuda-aviso">{aviso}</p>}
              {meta && (
                <p className="ic-hint">
                  Reportes analizados: {meta.reportes}
                  {meta.duplicados > 0
                    ? ` (${meta.duplicados} duplicados omitidos en la lista)`
                    : ""}
                </p>
              )}
              {items.length === 0 ? (
                <p>La IA no genero campos con contenido. Intente regenerar.</p>
              ) : (
                <div className="ic-ayuda-preview">
                  {items.map((it, idx) => (
                    <div key={idx} className="ic-ayuda-preview-item">
                      <strong>{it.label}</strong>
                      <p>{it.valor}</p>
                    </div>
                  ))}
                </div>
              )}
              <div className="ic-ayuda-acciones">
                <button type="button" className="boton" onClick={onAplicar}>
                  Aplicar al formulario
                </button>
                <button type="button" className="boton" onClick={onRegenerar}>
                  Regenerar
                </button>
                <button type="button" className="boton" onClick={onCerrar}>
                  Cancelar
                </button>
              </div>
            </>
          )}

          {!cargando && !error && !sugerencia && (
            <div className="ic-ayuda-acciones">
              <button type="button" className="boton" onClick={onCerrar}>
                Cerrar
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AyudaInformePlanModal;
